import {Component, Input, input, OnInit} from '@angular/core';
import {CheckboxModule} from "primeng/checkbox";
import {TooltipModule} from "primeng/tooltip";
import {FormsModule} from "@angular/forms";
import {AbstractProfileComponent} from "../abstract-profile.component";

@Component({
    selector: 'profile-checkbox',
    imports: [
    CheckboxModule,
    TooltipModule,
    FormsModule
],
    templateUrl: './profile-checkbox.component.html',
    styleUrl: './profile-checkbox.component.scss'
})
export class ProfileCheckboxComponent  extends AbstractProfileComponent implements OnInit {

    constructor() {
        super();
    }

// getPDCurrentValueBoolean(projectUUID: string, index: number): boolean {
    //     return this.getPDCurrentValueString(projectUUID, index) === 'true';
    // }
    //
    // setPDCurrentValueBoolean(projectUUID: string, index: number, value: boolean) {
    //     this.setPDCurrentValueString(projectUUID, index, value ? 'true' : 'false');
    // }
}

